import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiClient } from '@services/api';
import BreadCrumbs from '@components/Breadcrumbs';
import Button from '@components/Button';
import { format, isValid } from 'date-fns';
import { makeStyles } from '@material-ui/core'
import SelectSearch from 'react-select'
import { components } from "react-select";
import ChangeStateModal from './partials/ChangeStateModal';
import Icon from '@material-ui/core/Icon';
import Calendar from './partials/Calendar';
import Select from '@components/Select';
import { darkSelectStylesWide } from '@utils/darkSelectStyles';

const useStyles = makeStyles((theme) => ({
  tabs: {
    marginTop: 15
  }
}))

const Index = (props) => {
  const componentRef = useRef()
  const [rows] = useState([]);

  const [dateProof, setDateProof] = useState(null);
  const [search, setSearch] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [openModal, setOpenModal] = useState(false)
  const [selectedIdPayment, setSelectedIdPayment] = useState(null);
  const [sellers, setSellers] = useState([]);
  const [seller, setSeller] = useState('');
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState('');
  const [tours, setTours] = useState([]);
  const [tour, setTour] = useState('');
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState(null);

  //selects filters
  const [regionsIds, setRegionsIds] = useState('');
  const [sellersIds, setSellersIds] = useState('');
  const [toursIds, setToursIds] = useState('');

  //Menus select
  const [openMenuRegion, setOpenMenuRegion] = useState(false)
  const [openMenuProduct, setOpenMenuProduct] = useState(false)
  const [openMenuSeller, setOpenMenuSeller] = useState(false)

  const [seats, setSeats] = useState([])
  const [reservations, setReservations] = useState([])
  const [tourDates, setTourDates] = useState([])
  const urlSeats = '/cupos_general';
  const urlCompanies = '/companies';

  const [load, setLoad] = useState(true);


  const breadcrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin/fluxo-de-caixa'
    },
  ];

  const getSeats = (url, dataInicio, dataFim, companyId) => {
    let data = new Date();
    let primeiro = data.getDate() - data.getDay();
    let dataInicial = new Date(data.setDate(primeiro)).toUTCString();
    dataInicial = (data.getFullYear() + "-" + ((data.getMonth() + 1)) + "-" + (data.getDate()));
    let dataFinal = new Date(data.setDate(data.getDate() + 6)).toUTCString();
    dataFinal = (data.getFullYear() + "-" + ((data.getMonth() + 1)) + "-" + (data.getDate()));
    if (dataInicio === null) {
      dataInicio = dataInicial
    }
    if (dataFim === null) {
      dataFim = dataFinal
    }

    setLoad(true);
    setOpenMenuRegion(false)
    setOpenMenuProduct(false)
    setOpenMenuSeller(false)
    apiClient.httpInstance.get(url, {
      params: {
        tours_ids: toursIds.toString(),
        sellers_ids: sellersIds.toString(),
        regions_ids: regionsIds.toString(),
        company: companyId !== undefined ? companyId : company,
        data_inicial: dataInicio,
        data_final: dataFim,
      }
    }).then(response => {
      if (response.status === 200) {
        setReservations(response.data);
        setLoad(false);
      }
    });
  }

  const getRegions = () => {
    apiClient.httpInstance.get(`/regions`).then(response => {
      if (response.status === 200) {
        //let options = [{ value: 'all', name: 'Todas as regiões', label: 'Todas as regiões' }]
        let options = []
        response.data.map((element) => {
          options.push({ value: element.id, name: element.name, label: element.name })
        })
        options = options.sort(function (a, b) {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
        })

        setRegions(options)
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  const getSellers = () => {
    apiClient.httpInstance.get(`/users?seller=true&status=true&pageSize=1000`).then(response => {
      if (response.status === 200) {
        //let options = [{ value: '', name: 'Todos os vendedores', label: 'Todos os vendedores' }]
        let options = []
        response.data.data.map((element) => {
          options.push({ value: element.id, name: element.name, label: element.name })
        })
        setSellers(options)
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  const getTours = () => {
    apiClient.httpInstance.get(`/tours?pageSize=1000`).then(response => {
      if (response.status === 200) {
        //let options = [{ value: '', name: 'Todos os produtos', label: 'Todos os produtos' }]
        let options = []
        response.data.data.map((element) => {
          options.push({ value: element.id, name: element.name, label: element.name })
        })
        setTours(options)
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  const confirmPayment = () => {
    apiClient.httpInstance.put(`/confirm_sale_payment/${selectedIdPayment}`, {
      payment_id: selectedIdPayment
    }).then(response => {
      if (response.status === 200) {
        setOpenModal(false)
        setLoading(false)
      }
    })
      .catch((error) => console.log(error));
  }

  const getCompanies = url => {
    apiClient.httpInstance.get(`/companies?pageSize=500`).then(response => {
      if (response.status === 200) {
        let companies = response.data.data.sort(function (a, b) {
          return a.surname < b.surname ? -1 : a.surname > b.surname ? 1 : 0;
        })

        // Remove TourGo — não utilizado no front
        const filtered = companies.filter(c => !c.surname?.toLowerCase().includes('tourgo'));
        setCompanies(filtered);
        // Full Tour como empresa padrão
        const fullTour = filtered.find(c => c.surname?.toLowerCase().includes('full tour'));
        if (fullTour) {
          setCompany(fullTour.id);
          getSeats(urlSeats, null, null, fullTour.id);
        }
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  useEffect(() => {
    getSeats(urlSeats, null, null)
    getSellers();
    getRegions();
    getTours();
    getCompanies(urlCompanies);
  }, []);

  //Oculta menu lateral
  useEffect(() => {
    props.setShowMenu(false)
  }, []);

  useEffect(() => {
    document.querySelectorAll(".fc-day-today").forEach(el => el.style.backgroundColor = '#172B4D')
  }, [sellersIds, regionsIds, toursIds]);

  const handleSelect = (ev, type) => {
    setLoad(true);
    let newValues = ev.map((item) => {
      return item.value
    });

    if (type === 'region') {
      if (ev.length === 0) {
        setRegion('')
        setRegionsIds('')

        apiClient.httpInstance.get(urlSeats, {
          params: {
            regions_ids: '',
            tours_ids: toursIds.toString(),
            sellers_ids: sellersIds.toString(),
          }
        }).then(response => {
          if (response.status === 200) {
            setReservations(response.data);
          }
        });

      } else {
        setRegion(ev.name)
        setRegionsIds(newValues)
      }
    }

    if (type === 'tour') {
      if (ev.length === 0) {
        setTour('')
        setToursIds('')

        apiClient.httpInstance.get(urlSeats, {
          params: {
            tours_ids: '',
            sellers_ids: sellersIds.toString(),
            regions_ids: regionsIds.toString(),
          }
        }).then(response => {
          if (response.status === 200) {
            setReservations(response.data);
          }
        });
      } else {
        setTour(ev.name)
        setToursIds(newValues)
      }
    }

    if (type === 'seller') {
      if (ev.length === 0) {
        setSeller('')
        setSellersIds('')

        apiClient.httpInstance.get(urlSeats, {
          params: {
            tours_ids: toursIds.toString(),
            sellers_ids: '',
            regions_ids: regionsIds.toString(),
          }
        }).then(response => {
          if (response.status === 200) {
            setReservations(response.data);
          }
        });
      } else {
        setSeller(ev)
        setSellersIds(newValues)
      }
    }
    setLoad(false);
  }

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  return <>
    <div className="px-4 md:px-7">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue mb-3">
        <div className="flex items-center">
          <Icon className="mr-2">
            calendar_today
          </Icon>
          <span>Cupos</span>
        </div>
      </div>
      <div className="p-4 mt-4 bg-white border-1" style={{ borderRadius: '10px 10px 0px 0px' }}>
        <div className="flex flex-col md:flex-row flex-wrap md:items-center gap-3">
          <div className="w-full md:w-auto" style={{ position: 'relative', paddingTop: '18px' }}>
            <span style={AboveLabelStyle}>Região</span>
            <div style={SearchStyle1}>
              <span className='text-capitalize' style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', paddingLeft: '10px', color: openMenuRegion ? 'transparent' : (regionsIds?.length > 0 ? '#e8f0fb' : '#8ba5c4'), zIndex: 2, pointerEvents: 'none', borderRadius: '20px', fontSize: '14px' }}>{regionsIds?.length > 0 ? `${regionsIds?.length} selecionada` + (regionsIds?.length > 1 ? 's' : '') : 'Todas as regiões'}</span>
              <span style={SpanSelect}>
                <SelectSearch
                  styles={customStyles}
                  placeholder="Todas as regiões"
                  menuIsOpen={openMenuRegion}
                  onMenuOpen={() => setOpenMenuRegion(true)}
                  onMenuClose={() => setOpenMenuRegion(false)}
                  //options={regions}
                  options={regions.map(reg => ({
                    value: reg?.value,
                    name: reg?.name?.toLowerCase(),
                    label: reg?.name?.toLowerCase(),
                  }))}
                  isMulti
                  allowSelectAll={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  radioGroup
                  components={{
                    Option, //MenuList: SelectMenuButton
                  }}
                  showSelectedItems={false}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  value={region}
                  onChange={(ev) => handleSelect(ev, 'region')}
                  name="region"
                /></span>
            </div>
          </div>
          <div className="w-full md:w-auto" style={{ position: 'relative', paddingTop: '18px' }}>
            <span style={AboveLabelStyle}>Produtos</span>
            <div style={SearchStyle2}>
              <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', paddingLeft: '10px', color: openMenuProduct ? 'transparent' : (toursIds?.length > 0 ? '#e8f0fb' : '#8ba5c4'), zIndex: 2, pointerEvents: 'none', borderRadius: '20px', fontSize: '14px' }}>{toursIds?.length > 0 ? `${toursIds?.length} selecionado` + (toursIds?.length > 1 ? 's' : '') : 'Todos os produtos'}</span>
              <span style={SpanSelect}><SelectSearch
                styles={customStyles}
                placeholder="Todos os produtos"
                menuIsOpen={openMenuProduct}
                onMenuOpen={() => setOpenMenuProduct(true)}
                onMenuClose={() => setOpenMenuProduct(false)}
                options={tours.map(tou => ({
                  value: tou?.value,
                  name: tou?.name?.toLowerCase(),
                  label: tou?.name?.toLowerCase(),
                }))}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option,
                }}
                allowSelectAll={true}
                showSelectedItems={false}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                value={tour}
                onChange={(ev) => handleSelect(ev, 'tour')}
                name="product"
              /></span>
            </div>
          </div>
          <div className="w-full md:w-auto" style={{ position: 'relative', paddingTop: '18px' }}>
            <span style={AboveLabelStyle}>Vendedor</span>
            <div style={SearchStyle3}>
              <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', paddingLeft: '10px', color: openMenuSeller ? 'transparent' : (sellersIds?.length > 0 ? '#e8f0fb' : '#8ba5c4'), zIndex: 2, pointerEvents: 'none', borderRadius: '20px', fontSize: '14px' }}>{sellersIds?.length > 0 ? `${sellersIds?.length} selecionado` + (sellersIds?.length > 1 ? 's' : '') : 'Todos os vendedores'}</span>
              <span style={SpanSelect}><SelectSearch
                styles={customStyles}
                placeholder="Todos os vendedores"
                menuIsOpen={openMenuSeller}
                onMenuOpen={() => setOpenMenuSeller(true)}
                onMenuClose={() => setOpenMenuSeller(false)}
                options={sellers.map(sel => ({
                  value: sel?.value,
                  name: sel?.name?.toLowerCase(),
                  label: sel?.name?.toLowerCase(),
                }))}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{
                  Option,
                }}
                allowSelectAll={true}
                showSelectedItems={false}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                value={seller}
                onChange={(ev) => handleSelect(ev, 'seller')}
                name="seller"
              /></span>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <Button
              textcolor="#fff"
              margintop="4px"
              padding="6px 30px"
              color="primary"
              size="large"
              width="150px"
              type="button"
              variant="text"
              className="cursor-pointer"
              onClick={() => getSeats(urlSeats, null, null)}
            >
              Filtrar
            </Button>
          </div>
        </div>
        <div className="p-3 mt-2" style={{ width: '100%', position: 'relative', minHeight: '500px', overflowY: 'auto', overflowX: 'auto' }}>
          <Calendar {...props} reservations={reservations} cupos={seats} dates={tourDates} getSeats={getSeats} load={load} />
        </div>
      </div>
    </div>
    <ChangeStateModal
      open={openModal}
      close={() => setOpenModal(false)}
      onCreate={confirmPayment}
      status={status}
      selectedIdPayment={selectedIdPayment}
      setStatus={setStatus}
    />
  </>
}

export default Index;

const customStyles = darkSelectStylesWide

const SearchStyleBase = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minWidth: '200px',
  justifyContent: 'space-between',
  borderRadius: '20px',
  border: '1px solid #2a4f72',
  backgroundColor: '#1e3a5a',
  padding: '10px 10px',
  minHeight: '48px',
  position: 'relative',
  color: '#e8f0fb',
  boxSizing: 'border-box',
}
const SearchStyle1 = { ...SearchStyleBase, zIndex: '10007' }
const SearchStyle2 = { ...SearchStyleBase, zIndex: '10004' }
const SearchStyle3 = { ...SearchStyleBase, zIndex: '10003' }

const AboveLabelStyle = {
  position: 'absolute',
  top: '2px',
  left: '12px',
  fontSize: '13px',
  color: '#8ba5c4',
  fontWeight: '600',
  zIndex: 10,
  pointerEvents: 'none',
  whiteSpace: 'nowrap',
}

const SpanSelect = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
}

const legendLanguage = {
  display: 'flex',
  padding: '1px',
  backgroundColor: '#E4E2FB',
  borderRadius: '50px',
  width: '20px',
  height: '20px',
  color: '#009976',
  justifyContent: 'center',
  marginInlineEnd: '2px'
}

const legendSeller = {
  display: 'flex',
  padding: '1px',
  backgroundColor: '#E4E2FB',
  borderRadius: '5px',
  width: '25px',
  height: '25px',
  color: '#009976',
  justifyContent: 'center',
  marginInlineEnd: '2px'
}

const legendHand = {
  display: 'flex',
  padding: '1px',
  backgroundColor: '#E4E2FB',
  borderRadius: '5px',
  width: '25px',
  height: '25px',
  color: '#009976',
  justifyContent: 'center',
  marginInlineEnd: '2px'
}